module.exports = __webpack_public_path__ + "static/media/pool-dark-gray.70f627fe.svg";